import React from 'react'
import loader from '../assets/loader.gif';


const Loading = () => {
  return (
    <div className='flex justify-center'><img width={20} src={loader} alt="loader" /></div>
  )
}

export default Loading